import { createEffect } from "effector";
import { toQueryString } from "../../../shared/lib/url/toQueryString";
import axios from "axios";
import { TRequestParams } from "../../../shared/commonTypes/commonTypes";
import { handleAxiosError } from "../../../shared/lib/error/handleAxiosError";
import { IValidateResponse } from "./types";


export const validateTokenFx = createEffect(async (params: TRequestParams) => {
	const query = toQueryString(params);
	
	try {
		await axios.get<IValidateResponse>(`${process.env.REACT_APP_BASE_URL}/auth/password/reset-verify?` + query);
	}
	catch (error: unknown) {
		handleAxiosError(error);
	}
})
